import { render, staticRenderFns } from "./supplyPriorityConfigurationModal.vue?vue&type=template&id=df3e219a&scoped=true"
import script from "./supplyPriorityConfigurationModal.vue?vue&type=script&lang=js"
export * from "./supplyPriorityConfigurationModal.vue?vue&type=script&lang=js"
import style0 from "./supplyPriorityConfigurationModal.vue?vue&type=style&index=0&id=df3e219a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3e219a",
  null
  
)

export default component.exports